import * as React from 'react';
import styled from 'styled-components';

import { VariantsGrid } from '@process-advisor/process-miner/slicers/variants/variantsGrid';
import { SingleBlock } from '@process-advisor/process-miner/slicers/variants/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';

import { Button as MaterialButton } from '@mui/material';
import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const StyledMaterialButton = styled(MaterialButton)`
    background-color: ${getColor('white')};
    border: 1px solid ${getColor('lightBorderColor')};
    border-radius: 8px;
    text-transform: none;
    padding: 3px 3px;
    font-weight: 550;
    font-size: 10px;
    & span {
        text-align: center;
        text-transform: none;
        color: ${getColor('blue')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('input')};
        line-height: ${getLineHeight('smallest')};
        padding: 3px;
    }
    &:hover {
        border-color: ${getColor('blue')};
    }
    &:disabled {
        & .MuiButton-label {
            color: #A6A6A6;
        }
        background-color: #E0E0E0;
    }
`;

import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';


const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

const TopWrapper = styled(SingleBlock)`
    flex-direction: row;
    padding: 2px;
`;

const HelpText = styled.div`
    font-size: 12px;
    color: #6b778c;
    font-style: italic;
    white-space: nowrap;
    padding: 8px 12px;
    text-align: center;
`;

export const VariantsSelector = (mode) => {
    
    async function setTopX (variants) {
        let topX = []

        let data = apiProvider.variantsTable({});

        for (let i = 0; i < variants; i++) {
           let vtp = {}
           vtp['sequence'] = data[i].sequence
           topX.push(vtp)
        }
        apiProvider.setVariantSlicerSelectedData({ selection: topX, source: 'variants RC', mode: mode.mode});
        let eventEmitter = apiProvider.getEventEmitter()
        eventEmitter.emit(Event.setTopXVariants);
    };

    return (
    <Wrapper>
        <SingleBlock borderBottom>
            <VariantsGrid mode={mode.mode} />
        </SingleBlock>
        <TopWrapper>
            <SingleBlock width="20%">
                <StyledMaterialButton onClick={() => {setTopX(5)}}>Top 5</StyledMaterialButton>
            </SingleBlock>
            <SingleBlock width="20%">
                <StyledMaterialButton onClick={() => {setTopX(10)}}>Top 10</StyledMaterialButton>
            </SingleBlock>
            <SingleBlock width="20%">
                <StyledMaterialButton onClick={() => {setTopX(20)}}>Top 20</StyledMaterialButton>
            </SingleBlock>
            <SingleBlock width="20%">
                <StyledMaterialButton onClick={() => {setTopX(50)}}>Top 50</StyledMaterialButton>
            </SingleBlock>
            <SingleBlock width="20%">
                <StyledMaterialButton onClick={() => {setTopX(100)}}>Top 100</StyledMaterialButton>
            </SingleBlock>
        </TopWrapper>
        <HelpText>Right mouse click a variant for analysis options</HelpText>
        <AlertMessage/>
    </Wrapper>
    )
};

